import React from 'react';
import { colors } from '@styleseat/brand';

type SecurityVerifiedIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SecurityVerifiedIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: SecurityVerifiedIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.22183 19.7782C3.29761 18.854 3.03247 17.4442 3.32231 15.5944C1.80938 14.4914 1 13.307 1 12C1 10.693 1.80938 9.50862 3.32231 8.40558C3.03247 6.55582 3.29761 5.14604 4.22183 4.22183C5.14604 3.29761 6.55582 3.03247 8.40558 3.32231C9.50862 1.80938 10.693 1 12 1C13.307 1 14.4914 1.80938 15.5944 3.32231C17.4442 3.03247 18.854 3.29761 19.7782 4.22183C20.7024 5.14604 20.9675 6.55582 20.6777 8.40558C22.1906 9.50862 23 10.693 23 12C23 13.307 22.1906 14.4914 20.6777 15.5944C20.9675 17.4442 20.7024 18.854 19.7782 19.7782C18.854 20.7024 17.4442 20.9675 15.5944 20.6777C14.4914 22.1906 13.307 23 12 23C10.693 23 9.50862 22.1906 8.40558 20.6777C6.55582 20.9675 5.14604 20.7024 4.22183 19.7782ZM8.65258 18.598C9.05851 18.5111 9.47594 18.684 9.7015 19.0325C10.5823 20.3933 11.3676 21 12 21C12.6324 21 13.4177 20.3933 14.2985 19.0325C14.5241 18.684 14.9415 18.5111 15.3474 18.598C16.9325 18.9374 17.9168 18.8111 18.364 18.364C18.8111 17.9168 18.9374 16.9325 18.598 15.3474C18.5111 14.9415 18.684 14.5241 19.0325 14.2985C20.3933 13.4177 21 12.6324 21 12C21 11.3676 20.3933 10.5823 19.0325 9.7015C18.684 9.47594 18.5111 9.05851 18.598 8.65258C18.9374 7.06755 18.8111 6.08319 18.364 5.63604C17.9168 5.18889 16.9325 5.06256 15.3474 5.40202C14.9415 5.48895 14.5241 5.31605 14.2985 4.96754C13.4177 3.60672 12.6324 3 12 3C11.3676 3 10.5823 3.60672 9.7015 4.96754C9.47594 5.31605 9.05851 5.48895 8.65258 5.40202C7.06755 5.06256 6.08319 5.18889 5.63604 5.63604C5.18889 6.08319 5.06256 7.06755 5.40202 8.65258C5.48895 9.05851 5.31605 9.47594 4.96754 9.7015C3.60672 10.5823 3 11.3676 3 12C3 12.6324 3.60672 13.4177 4.96754 14.2985C5.31605 14.5241 5.48895 14.9415 5.40202 15.3474C5.06256 16.9325 5.18889 17.9168 5.63604 18.364C6.08319 18.8111 7.06755 18.9374 8.65258 18.598ZM15.2929 8.29289L11 12.5858L8.70711 10.2929L7.29289 11.7071L11 15.4142L16.7071 9.70711L15.2929 8.29289Z"
      fill={color}
    />
  </svg>
);
